/*
  Image preview

  Load a preview of a loaded input file
*/
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = ['preview', 'container']

  load(e){
    let fi = this.element.querySelector('input[type=file]')
    let file = fi.files[0]

    if (file.type === 'image/jpeg')
      this.createPreviewFromExif(file)
    else
      this.createPreview(file)
  }

  createPreview(file) {
    this.previewTarget.replaceChildren(this.#createImage(file))
    this.containerTarget.classList.remove('hidden')
  }

  createPreviewFromExif(file) {
    let reader = new FileReader()
    reader.onload = (e) => {
      let array = new Uint8Array(e.target.result), start, end
      for (let i = 2; i < array.length; i++) {
        if (array[i] === 0xFF) {
          if (!start) {
            if (array[i + 1] === 0xD8)
              start = i
          } else {
            if (array[i + 1] === 0xD9) {
              end = i + 2
              break
            }
          }
        }
      }

      if (start && end) {
        const blob = new Blob([array.subarray(start, end)], { type: 'image/jpeg' })
        this.previewTarget.replaceChildren(this.#createImage(blob))
        this.containerTarget.classList.remove('hidden')
      } else {
        this.createPreview(file)
      }
    }

    reader.readAsArrayBuffer(file.slice(0, 80000))
  }

  #createImage(file) {
    const img = new Image()
    img.src = URL.createObjectURL(file)
    img.classList.add('max-w-full', 'max-h-full', 'object-fit')
    return img
  }
}
